import { debug } from './debug';
var pkgName = '@atlaskit/platform-feature-flags';
var hasProcessEnv = typeof process !== 'undefined' && typeof process.env !== 'undefined';

// FF global overrides can be configured by test runners or Storybook
var ENV_ENABLE_PLATFORM_FF = hasProcessEnv ?
// Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
process.env['ENABLE_PLATFORM_FF'] === 'true' : false;

// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270

var ENV_STORYBOOK_ENABLE_PLATFORM_FF = hasProcessEnv ?
// Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
process.env['STORYBOOK_ENABLE_PLATFORM_FF'] === 'true' : false;
var ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = ENV_ENABLE_PLATFORM_FF || ENV_STORYBOOK_ENABLE_PLATFORM_FF;
// In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
// This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
var flagsResolvedEarly = new Map();
var booleanResolver = function booleanResolver(flagKey) {
  if (process.env.NODE_ENV !== 'production') {
    var _flagsResolvedEarly$g;
    var unresolvedFlagCount = (_flagsResolvedEarly$g = flagsResolvedEarly.get(flagKey)) !== null && _flagsResolvedEarly$g !== void 0 ? _flagsResolvedEarly$g : 0;
    flagsResolvedEarly.set(flagKey, unresolvedFlagCount + 1);
  }
  return false;
};
export function setBooleanResolver(resolver) {
  booleanResolver = resolver;
  if (process.env.NODE_ENV !== 'production') {
    if (flagsResolvedEarly.size > 0) {
      debug("[%s]: The following list of Feature Flags were called, the following number of times, before setBooleanResolver.", pkgName, Array.from(flagsResolvedEarly.entries()));
      flagsResolvedEarly.clear();
    }
  }
}
export function resolveBooleanFlag(flagKey) {
  if (ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
    debug('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', pkgName, flagKey);
    return true;
  }
  try {
    var result = booleanResolver(flagKey);
    if (typeof result !== 'boolean') {
      // eslint-disable-next-line no-console
      console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
      return false;
    }
    return result;
  } catch (e) {
    return false;
  }
}